import { render } from "./AddSupplier.vue?vue&type=template&id=e495722c&scoped=true"
import script from "./AddSupplier.vue?vue&type=script&lang=js"
export * from "./AddSupplier.vue?vue&type=script&lang=js"

import "./AddSupplier.vue?vue&type=style&index=0&id=e495722c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e495722c"]])

export default __exports__